import React, { useEffect, useRef } from "react";
import classNames from "classnames/bind";
import image from '../../../../assets/images/Rectangle-5677.png';
import { Button, Loading, HeaderModal } from "../../../../components";
import styles from "./ModalInfo.module.css";
import { formatDateToTime } from "../../../../utils";

const cx = classNames.bind(styles);
const ModalInfo = ({ show, info, onClose, loading, openDetailPage }) => {
  const refModal = useRef()
  const handleClose = () => {
    onClose();
  };
  const handleMoreInfo = () => {
    sessionStorage.setItem('code', info.CODE)
    openDetailPage()
  }

  useEffect(() => {
    const handleCloseOnClickOutSide = (e) => {
      if (e.target === refModal.current) {
        onClose()
      }
    }
    document.addEventListener('click', handleCloseOnClickOutSide)
    return () => { document.removeEventListener('click', handleCloseOnClickOutSide) }
  }, [onClose])
  return (
    <>
      {show && (
        <div className={cx("modal-info")} ref={refModal}>
          <div className={cx("container")}>
            {loading ? <div className={cx('loading')}> <Loading /> </div> :
              <>
                <HeaderModal title={'Thông tin người dùng'} onClose={handleClose} />
                <div className={cx('avatar-container')}>
                  <div className={cx('avatar')}>
                    <img src={image} alt={'avatar'} className={cx('avatar-image')} />
                    <span className={cx('status')}>Bình thường</span>
                  </div>
                  <h1 className={cx('user-name')}>{info?.NAME ? info.NAME : ''}</h1>
                </div>
                <div className={cx('info-box-content')}>
                  <div className={cx('item-info')}>
                    <p className={cx('label')}>Tên đăng nhập</p>
                    <p className={cx('content')}>{info?.USERNAME ? info.USERNAME : ''}</p>
                  </div>
                  <div className={cx('item-info')}>
                    <p className={cx('label')}>Phân quyền</p>
                    <p className={cx('content')}>{info?.USERTYPE_NAME ? info.USERTYPE_NAME : ''}</p>
                  </div>
                  <div className={cx('item-info')}>
                    <p className={cx('label')}>Đơn vị</p>
                    <p className={cx('content')}>{info?.COMPANY_NAME ? info.COMPANY_NAME : ''}</p>
                  </div>
                  <div className={cx('item-info')}>
                    <p className={cx('label')}>Bắt đầu hoạt động</p>
                    <p className={cx('content')}>{info?.DATE_JOINED ? formatDateToTime(info.DATE_JOINED) : ''}</p>
                  </div>
                  <div className={cx('item-info')}>
                    <p className={cx('label')}>Sửa đổi lần cuối</p>
                    <p className={cx('content')}>{info?.EDIT_TIME ? formatDateToTime(info.EDIT_TIME) : ''}</p>
                  </div>
                </div>
                <div className={cx("actions", 'bottom')}>
                  <Button
                    onClick={handleClose}
                    className={cx("btn-close")}
                    title="Đóng"
                  />
                  <Button
                    onClick={handleMoreInfo}
                    className={cx("btn-setting")}
                    title="Xem chi tiết"
                  />
                </div>
              </>}
          </div>
        </div>
      )}
    </>
  );
};

export default ModalInfo;
